module.exports = __webpack_public_path__ + "img/section3-banner.c496d860.png";